<template>
  <v-card align="center" justify="center" min-width="25vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('createHitMistake') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-5">
      <v-form v-model="valid">
        <p class="text-center mt-3">{{ $t('createConsideration') }}</p>
        <v-select v-model="typeSelected" small-chips :items="types" item-text="text" item-value="value" :rules="typeRules" :label="$t('form_AddConsideration.type.label')" outlined/>
        <v-text-field :label="$t('form_AddConsideration.considerationName.label',{typeName: typeSelected})" :hint="(typeSelected === 'Mistake')? $t('form_AddConsideration.considerationName.hint1') : $t('form_AddConsideration.considerationName.hint2') "
                      :placeholder="(typeSelected === 'Mistake')? $t('form_AddConsideration.considerationName.placeholder1') : $t('form_AddConsideration.considerationName.placeholder2') "
                      v-model="name" :rules="nameRules" counter="17" outlined/>
        <v-btn class="my-3" :disabled="!valid" @click="createConsideration">{{ $t('create') }} {{ typeSelected }}</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/consideration';
import { mapMutations } from 'vuex';

export default {
  name: "AddConsideration",
  data() {
    return {
      valid: false,
      nameRules: [
        n => !!n || this.$t('form_AddConsideration.considerationName.rule1'),
        n => (n && n.length <= 17) || this.$t('form_AddConsideration.considerationName.rule2'),
      ],
      typeRules: [
        t => !!t || this.$t('form_AddConsideration.type.rule'),
      ],
      types: [
          { text: this.$t('types.hit'), value: 'Hit' },
          { text: this.$t('types.mistake'), value: 'Mistake' },
          { text: this.$t('types.other'), value: 'Other' },

      ],
      name: '',
      typeSelected: 'Hit',
    };
  },
  methods: {
    ...mapMutations(['setConsiderations']),
    createConsideration() {
      let consideration = {
        name: this.name,
        type: this.typeSelected.toUpperCase(),
        user: { id: this.$store.state.user.id },
      };

      Repository.createConsideration(consideration).then((response) => {
        if (response.status < 400) {
          Repository.getConsiderationsByUser(this.$store.state.user.id).then((secondResponse) => {
            if(secondResponse.status < 400) {
              this.setConsiderations(secondResponse.data);
              alert(this.$t('successfullCreation',{selectedType: this.typeSelected}));
            }
          });
          this.close();
        }
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>

</style>



